import { getAuth } from 'firebase/auth'
import * as Sentry from '@sentry/browser'
import { kPaxtonAppApiRESTBaseUrl } from '@/constants/constants-links'
import { readResponseJson, getResponseDebugContext } from '@/util/api/response-body'
import { ApiError } from '@/util/errors/api-error'
import { ApiResponsePayloadError } from '@/util/errors/api-response-payload-error'
import { TableLayout, TableLayoutSchema } from '../layout'

export async function tableLayoutRequest(tableId: string, layout?: TableLayout, signal?: AbortSignal): Promise<TableLayout> {
  const token = await getAuth().currentUser?.getIdToken()
  if (!token) throw new Error('Sign in to access table layouts.')
  const url = `${kPaxtonAppApiRESTBaseUrl()}/api/v1/tables/${tableId}/layout`
  const response = await fetch(url, {
    method: layout ? 'PUT' : 'GET',
    headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
    body: layout ? JSON.stringify(layout) : undefined,
    signal,
  })
  const { data, parseError } = await readResponseJson(response)
  signal?.throwIfAborted()
  if (!response.ok) {
    if (response.status >= 500) Sentry.captureException(new Error('Table layout request failed'), { extra: getResponseDebugContext(response, url) })
    throw new ApiError(response.status, 'Unable to load or save your table layout.')
  }
  const parsed = TableLayoutSchema.safeParse(data)
  if (parseError || !parsed.success) {
    Sentry.captureException(new Error('Invalid table layout response'), { extra: getResponseDebugContext(response, url) })
    throw new ApiResponsePayloadError(response.status, 'The table layout response could not be read.')
  }
  return parsed.data
}
